/**
 * Sorgente XML dell'icona Follia.
 * Estratto direttamente dal file .svg originale per inlining tramite MatIconRegistry.
 * * @constant
 */

export const FOLLIA_SVG_DATA = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.1 218.8">
  <path fill="#161616" d="M135.3,15.1H58.1c-4.6,0-8.3,3.7-8.3,8.3v26.8h85.4c4.6,0,8.3-3.7,8.3-8.3v-18.5c0-4.6-3.7-8.3-8.3-8.3Z"/>
  <path fill="#161616" d="M12.6,58.3v17.8c0,4.6,3.7,8.3,8.3,8.3h29v-34.3h-29c-4.6,0-8.3,3.7-8.3,8.3Z"/>
  <path fill="#161616" d="M58.1,203.8h19.2c4.6,0,8.3-3.7,8.3-8.3v-68.4c0-4.6,3.7-8.3,8.3-8.3h41.5c4.6,0,8.3-3.7,8.3-8.3v-18c0-4.6-3.7-8.3-8.3-8.3H49.8v111.2c0,4.6,3.7,8.3,8.3,8.3h0Z"/>
</svg>`;

export const FOLLIA_GRADIENT_SVG_DATA = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.1 218.8">
  <defs>
    <linearGradient id="grad_follia_8" x1="49.8" y1="32.6" x2="127.2" y2="32.6" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#80bb3d"/>
      <stop offset="1" stop-color="#1489a3"/>
    </linearGradient>
    <linearGradient id="grad_follia_9" x1="12.6" y1="67.2" x2="157.9" y2="67.2" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#80bb3d"/>
      <stop offset="1" stop-color="#1489a3"/>
    </linearGradient>
  </defs>
  <path fill="url(#grad_follia_8)" d="M135.3,15.1H58.1c-4.6,0-8.3,3.7-8.3,8.3v26.8h85.4c4.6,0,8.3-3.7,8.3-8.3v-18.5c0-4.6-3.7-8.3-8.3-8.3Z"/>
  <path fill="url(#grad_follia_9)" d="M12.6,58.3v17.8c0,4.6,3.7,8.3,8.3,8.3h29v-34.3h-29c-4.6,0-8.3,3.7-8.3,8.3Z"/>
  <path fill="url(#grad_follia_8)" d="M58.1,203.8h19.2c4.6,0,8.3-3.7,8.3-8.3v-68.4c0-4.6,3.7-8.3,8.3-8.3h41.5c4.6,0,8.3-3.7,8.3-8.3v-18c0-4.6-3.7-8.3-8.3-8.3H49.8v111.2c0,4.6,3.7,8.3,8.3,8.3h0Z"/>
</svg>`;
